module.exports = __webpack_public_path__ + "static/media/sageone.85e80274.svg";